module.exports = __webpack_public_path__ + "a8a10a3e/img/question-icon.06c20c5d.svg";